import React, { ReactNode } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  
  // Páginas que usam layout full-width sem padding
  const fullWidthPages = ['/dashboard', '/trips', '/profile', '/companions'];
  const isFullWidth = fullWidthPages.includes(location.pathname) || location.pathname.startsWith('/trips/');

  if (!isAuthenticated) {
    return <div className="min-h-screen bg-gray-50">{children}</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className={`flex-1 lg:ml-64 ${isFullWidth ? 'pt-16' : 'pt-16 p-4 lg:p-6'}`}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
